import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'bho',
    fullName: 'Bhojpuri',
    nativeName: 'भोजपुरी',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "आर्गवोइड के बा",
    landing_title: "कुछ गजब के बात आ रहल बा",
    landing_subtitle: "आर्गवॉइड एगो ऐप आ गेम डेवलपमेंट स्टूडियो हवे। जुडल रहीं, जल्दिये नया बात आवे वाला बा!",
    select_language: "भाषा के चयन करीं",
    search_placeholder: "भाषा के खोज करीं...",
    terms_title: "सेवा के शर्त बा",
    policy_title: "गोपनीयता नीति के बारे में बतावल गइल बा",
    cookies_title: "कुकी नीति के बारे में बतावल गइल बा",
    terms_content: `
        <strong>1 के बा। शर्तन के स्वीकृति</strong><br> के बा
        ArgVoid तक पहुँच के, ई सेवा के शर्त स्वीकार कइल जाला। अगर एह शर्तन पर सहमत ना होखे त सेवा के इस्तेमाल ना करे के चाहीं.<br><br>

        <strong>2 के बा। प्लेटफार्म के उपयोग</strong><br> के बा
        आर्गवॉइड आ एकर एप्लीकेशन सभ के जानकारी आ रचनात्मक उद्देश्य खातिर "जइसन बा" उपलब्ध करावल गइल बा। सेवा के इस्तेमाल खाली कानूनी उद्देश्य खातिर होखे के चाहीं।<br><br>

        एक्स10एक्स3 के बा। निषिद्ध आचरण</strong><br> के बा
        साइट के कमजोरी के फायदा उठावल, स्पैमिंग, भा बुनियादी ढांचा में अनधिकृत पहुँच के कोशिश कइल सख्ती से मना बा.<br><br>

        एक्स15एक्स4 के बा। अस्वीकरण</strong><br> के बा
        प्लेटफार्म आ सेवा में कबो भी बिना सूचना के संशोधन कइल जा सकेला। सेवा के अपटाइम भा उपलब्धता के संबंध में कवनो वारंटी नईखे दिहल गईल।
    `,
    policy_content: `
        <strong>1 के बा। सूचना संग्रहण</strong><br> के बा
        एह प्लेटफार्म पर एह समय यूजर प्रमाणीकरण भा खाता बनावे के जरूरत नइखे. विजिटर से कवनो निजी पहचान करे वाला जानकारी (जइसे कि नाम भा ईमेल पता) सक्रिय रूप से एकट्ठा ना कइल जाला.<br><br>

        <strong>2 के बा। उपयोग डेटा</strong><br> के बा
        साइट के ट्रैफिक के समझे आ एप्लीकेशन सभ में सुधार खातिर बेसिक, बेनामी एनालिटिक्स एकट्ठा कइल जा सके ला। ई डेटा अलग-अलग प्रयोगकर्ता पहचान से जुड़ल नइखे।<br><br>

        एक्स10एक्स3 के बा। थर्ड-पार्टी सेवा</strong><br> के बा
        होस्टिंग आ एनालिटिक्स सेवा खातिर थर्ड पार्टी प्रदाता लोग के इस्तेमाल कइल जा सके ला। एह संबंधित प्रदाता लोग के गोपनीयता प्रथा उनके बुनियादी ढांचा पर संसाधित बेनामी डेटा के नियंत्रित करे ला।<br><br>

        एक्स15एक्स4 के बा। डेटा सुरक्षा</strong><br> के बा
        प्लेटफार्म के सुरक्षा खातिर उचित सुरक्षा उपाय लागू कइल जाला। हालांकि इंटरनेट पर संचरण के कवनो तरीका पूरा तरह से सुरक्षित नइखे.<br><br>
    `,
    cookies_content: `
        <strong>1 के बा। कुकीज आ स्थानीय भंडारण का होला?</strong><br>
        कुकीज आ ब्राउजर लोकल स्टोरेज डिवाइस पर संग्रहीत छोट डेटा फाइल हवें जे पूरा विजिट.<br><br> में कॉन्फ़िगरेशन पसंद के याद राखे खातिर

        <strong>2 के बा। उपयोग के उद्देश्य</strong><br> के बा
        ब्राउजर लोकलस्टोरेज के इस्तेमाल कॉन्फ़िगरेशन सेटिंग के सेव करे खातिर सख्ती से कइल जाला, जइसे कि:<br>
        - भाषा के पसंद<br> के बा
        - यूजर इंटरफेस कॉन्फ़िगरेशन (जइसे कि, लेआउट या थीम सेटिंग)<br>
        - अस्थायी आवेदन कैश<br><br> बा

        एक्स13एक्स3 के बा। कवनो ट्रैकिंग</strong><br> ना
        कुकीज आ स्थानीय भंडारण के इस्तेमाल विज्ञापन भा थर्ड पार्टी ट्रैकिंग के मकसद से ना कइल जाला. सभ संग्रहीत डेटा सख्ती से प्लेटफार्म के कोर कार्यक्षमता खातिर बा।<br><br>

        एक्स18एक्स4 के बा। नियंत्रण</strong><br> के बा
        ब्राउजर सेटिंग के माध्यम से कबो भी ब्राउजर डेटा के साफ कईल जा सकता, जवन कि कवनो स्थानीय कॉन्फ़िगरेशन के रीसेट क दिही।
    `,
    cookie_consent_text: "हमनी के वेबसाइट के सही तरीका से काम करे के सुनिश्चित करे खातिर बेसिक कुकीज़ के इस्तेमाल करेनी जा, जइसे कि राउर सत्र सक्रिय राखल, राउर भाषा पसंद के सहेजल, आ अउरी कस्टम कॉन्फ़िगरेशन.",
    read_policy: "कुकी नीति पढ़ीं",
    support_title: "समर्थन से संपर्क करीं",
    support_subject_label: "बिषय",
    support_message_label: "सनेस",
    support_submit_button: "संदेश भेजल जाला",
    support_hint: "नोट: एह से संदेश भेजे खातिर राउर डिफ़ॉल्ट ईमेल एप्लीकेशन खुल जाई।",
    support_success_msg: "आपन ईमेल ऐप खोलत बानी...",
    support_error_msg: "संदेश भेजे में नाकाम रहल। कृपया बाद में दोबारा कोशिश करीं।",
    explorer_title: "एक्सप्लोरर के बा",
    history_title: "इतिहास",
    animation_title: "एनीमेशन के बारे में बतावल गइल बा",
    config_title: "कॉन्फ़िगरेशन के बारे में बतावल गइल बा",
    tool_mouse: "(Ctrl+M) के चयन करीं।",
    tool_brush: "ब्रश (सीटीआरएल+बी) के बा।",
    tool_brush_mode: "टॉगल मोड (ठोस/साफ) के बा।",
    tool_eraser: "इरेजर (सीटीआरएल+ई) के बा।",
    tool_brush_size: "ब्रश के आकार समायोजित करीं",
    tool_bucket: "भरल (Ctrl+F) के बा।",
    tool_eyedropper: "आईड्रॉपर के बा",
    tool_grid: "ग्रिड (सीटीआरएल + शिफ्ट + बी) के बा।",
    tool_rotate: "घुमावल (Ctrl+Shift+R) के बा।",
    tool_flip_h: "फ्लिप एच (सीटीआरएल + शिफ्ट + एच) के बा।",
    tool_flip_v: "फ्लिप वी (सीटीआरएल + शिफ्ट + वी) के बा।",
    tool_transpose: "ट्रांसपोज (सीटीआरएल + शिफ्ट + टी) के बा।",
    label_width: "चौड़ाई",
    label_height: "ऊँचाई",
    label_frames: "फ्रेम के संख्या बा",
    label_animation: "एनीमेशन स्टाइल के बा",
    label_background_color: "पृष्ठभूमि के रंग के बा",
    label_interval: "अंतराल के बा",
    tool_anim_config: "एनीमेशन कॉन्फ़िगरेशन के बारे में बतावल गइल बा",
    label_new_width: "नया चौड़ाई के बा",
    label_new_height: "नया ऊँचाई के बा",
    label_apply: "लागू करीं",
    label_colors: "रंग-बिरंग के बा",
    label_size: "आकार",
    label_tolerance: "सहनशीलता",
    val_horizontal: "क्षैतिज",
    val_vertical: "खड़ा",
    val_sequence: "अनुक्रम",
    val_bounce: "उछाल",
    val_random: "सतमेरवनी",
    val_solid: "ठोस",
    val_clear: "साफ",
    action_add_sheet: "नया चादर के बा",
    action_import: "आयात",
    action_export: "निर्यात",
    action_sort_projects: "क्रम में सजावल",
    sort_date_old: "सबसे पुरान पहिला",
    sort_date_new: "सबसे नया सबसे पहिले",
    sort_name_az: "नाम (ए-जेड) के बा।",
    sort_name_za: "नाम (जेड-ए) के बा।",
    action_new_sprite: "नया स्प्राइट के बा",
    action_new_project: "नया परियोजना के बारे में बतावल गइल बा",
    modal_save_all_title: "सभ बदलाव के सहेज लीं",
    modal_save_all_desc: "सेव करे खातिर संपत्ति के चयन करीं:",
    modal_save_selected: "सेव चुनल गइल बा",
    action_saved: "सहेजल गइल बा",
    modal_create_sprite_title: "नया स्प्राइट बनाईं",
    modal_create_project_title: "नया प्रोजेक्ट बनाईं",
    modal_add_sheet_title: "नया शीट जोड़ल जाव",
    modal_rename_sheet_title: "शीट के नाम बदल दिहल जाव",
    modal_rename_sprite_title: "स्प्राइट के नाम बदल दिहल जाव",
    modal_delete_sprite_title: "स्प्राइट के हटा दिहल जाव",
    modal_delete_project_title: "प्रोजेक्ट के हटा दिहल जाव",
    modal_delete_sheet_title: "शीट के हटावे के बा",
    placeholder_sprite_name: "नांव",
    placeholder_project_name: "नांव",
    placeholder_sheet_name: "नांव",
    placeholder_new_name: "नया नाम के नाम बा",
    action_create: "बनावल",
    action_add: "जोड़ल",
    action_rename: "नाम बदल दिहल जाव",
    action_duplicate: "डुप्लिकेट कइल जाला",
    action_delete: "हटाईं",
    action_cancel: "मना कइ दीं",
    confirm_delete_sprite: "का रउआँ पक्का बानी कि रउआँ ई स्प्राइट हटावल चाहत बानी?",
    confirm_delete_project: "का रउआँ पक्का बानी कि रउआँ एह प्रोजेक्ट के हटावल चाहत बानी? सभ स्प्राइट हटा दिहल जाई।",
    confirm_delete_sheet: "का रउआँ पक्का बानी कि रउआँ ई शीट हटावल चाहत बानी?",
    err_select_sprite: "कृपया पहिले कवनो स्प्राइट चुनीं।",
    err_select_project: "कृपया पहिले कवनो प्रोजेक्ट चुनीं।",
    err_name_empty: "नाम खाली ना हो सकेला।",
    err_sprite_exists: "ओह नाम के स्प्राइट पहिलहीं से मौजूद बा.",
    err_project_exists: "ओह नाम के एगो प्रोजेक्ट पहिलहीं से मौजूद बा.",
    err_no_content: "सेव करे खातिर कवनो सामग्री नइखे.",
    err_no_changes: "बचावे खातिर कवनो बदलाव ना भइल.",
    err_delete_last_sheet: "अंतिम शीट के हटावल नइखे जा सकत।",
    err_extract_frames: "कवनो फ्रेम ना निकाल पवलस।",
    err_indexeddb: "स्थानीय रूप से सेव करे में नाकाम रहल। हो सकेला कि राउर ब्राउजर IndexedDB के सपोर्ट ना करे.",
    msg_upload_success: "अपलोड सफल भइल: {0}",
    msg_upload_failed: "अपलोड असफल हो गइल: {0}",
    msg_save_success: "बचावे सफल हो गइल।",
    msg_saving: "बचत हो रहल बा...",
    msg_multi_save_result: "{0} संपत्ति के सहेजल गइल। {1} असफलता के बा।",
    menu_title: "मेनू में बा",
    menu_save: "बचावल",
    menu_save_all: "सब के बचाईं",
    menu_support: "समर्थन से संपर्क करीं",
    label_local_storage: "स्थानीय भंडारण के बारे में बतावल गइल बा",
    label_sign_in: "साइन इन करीं",
    modal_export_title: "स्प्राइट के निर्यात कइल जाला",
    label_filename: "फाइल के नाम बा",
    label_format: "प्रारूप के बा",
    action_export_confirm: "निर्यात",
};

export default translations;
